var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mt-0",attrs:{"value":true,"color":_vm.config.color}},[_c('span',[_vm._v(_vm._s(_vm.config.text))]),_c('strong',[_vm._v(": "+_vm._s(_vm.config.explanation))])])}
var staticRenderFns = []

export { render, staticRenderFns }